import { useTranslation } from '@sm360/hooks'
import { Button, Modal } from '@sm360/ui-library'
import React from 'react'

import { Context } from '../../configs/state.manager'
import { WindowProxy } from '../../utils/handle-url.utils'
import { updateQuote } from '../../utils/showroom.utils'
import '@sm360/payment-calculator-360/dist/views/modal/modal.view.css'

const ModalView = ({ children }) => {
    const {
        state: { paymentOptions, quoteInfos, vehicle, calculatorCtaVersion, isStandaloneVLP },
    } = React.useContext(Context)

    const { t } = useTranslation()
    const [hasQuoteInGarage, setHasQuoteInGarage] = React.useState(false)

    const [isModalOpen, setModalOpen] = React.useState(false)

    const onSetClose = (setClose) => {
        document.body.style.overflow = 'auto'
        document.body.style.paddingRight = '0px'
        setClose && setClose()
        if (isModalOpen) {
            if (WindowProxy) {
                setModalOpen(false)
                setTimeout(() => WindowProxy.document.dispatchEvent(new Event('sm360.calculator.vlp.modal.close')), 1000)
            }
        }
        if (!isStandaloneVLP) {
            if (hasQuoteInGarage) {
                updateQuote(quoteInfos, paymentOptions, vehicle)
            }
            WindowProxy.document.dispatchEvent(
                new CustomEvent('sm360.calculator.vdp.modal.close', {
                    detail: {
                        paymentOptions,
                    },
                })
            )
        }
    }

    return (
        <Modal
            modalTitle=''
            isModalOpen={isStandaloneVLP}
            trigger={
                !isStandaloneVLP && (
                    <div>
                        <Button className={`a-button ${calculatorCtaVersion}`} label={t('pc.configureMyPayment')} />
                    </div>
                )
            }
            className='pc-modal__inner'
            onCancel={() => onSetClose()}
            onClose={() => onSetClose()}
        >
            {children}
        </Modal>
    )
}

export default ModalView
